import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { DMAcceptorStartBlocker, DMAcceptorType } from '@nsftx/systems-sdk'
import type { AcceptorStartBlockers } from '#src/interfaces/AcceptorStartBlockers'

const useDeviceManagementAcceptorsStore = defineStore('deviceManagementAcceptorsStore', () => {
  const acceptorStartBlockers = ref<AcceptorStartBlockers>({
    bill: [],
    coin: []
  })

  const isAcceptorsStartBlocked = computed(
    () => !!(acceptorStartBlockers.value.bill.length || acceptorStartBlockers.value.coin.length)
  )

  const setAcceptorStartBlockers = (
    blockers: AcceptorStartBlockers | DMAcceptorStartBlocker[],
    acceptor?: DMAcceptorType
  ) => {
    if (!acceptor) {
      const { bill, coin } = blockers as AcceptorStartBlockers
      acceptorStartBlockers.value = {
        ...acceptorStartBlockers.value,
        bill: [...bill],
        coin: [...coin]
      }

      return
    }

    acceptorStartBlockers.value = {
      ...acceptorStartBlockers.value,
      [acceptor]: [...(blockers as DMAcceptorStartBlocker[])]
    }
  }

  return {
    acceptorStartBlockers,
    isAcceptorsStartBlocked,
    setAcceptorStartBlockers
  }
})

export { useDeviceManagementAcceptorsStore }
